import LocalizedStrings from 'react-localization';
import store from '../redux/store';
import en from './i18n/en.json';
import vi from './i18n/vi.json';

// 初始化多语言实例
const strings = new LocalizedStrings({ en, vi });

/**
 * 国际化翻译函数
 * @param {string} key - 翻译键值，如: 'common.button.submit'
 * @param {Object} [params] - 可选的模板参数对象，如: { name: 'John', time: '2024-01-01' }
 * @example
 * // 基础使用
 * t('common.welcome')  // => '欢迎'
 *
 * // 带参数
 * t('common.hello', { name: 'John' })  // => 'Hello John'
 */
export const t = (key, params = null) => {
  // 参数校验
  if (typeof key !== 'string') {
    console.error('Translation key must be a string');
    return '';
  }

  // 获取当前语言并设置
  const currentLang = store.getState().app.language;
  const availableLanguages = strings.getAvailableLanguages() || [];
  if (availableLanguages.includes(currentLang)) {
    strings.setLanguage(currentLang);
  } else {
    console.warn(`Language not available: ${currentLang}, available languages: ${JSON.stringify(availableLanguages)}`);
  }

  // 检查 key 是否存在, 不存在则返回 key 本身
  if (!(key in strings)) {
    return key;
  }

  let translatedText = strings[key];

  // 处理模板参数替换
  if (params && typeof params === 'object') {
    try {
      Object.keys(params).forEach(paramKey => {
        const paramValue = params[paramKey]?.toString() || '';
        const regex = new RegExp(`{${paramKey}}`, 'g');
        translatedText = translatedText.replace(regex, paramValue);
      });
    } catch (error) {
      console.error(`Error replacing parameters for key "${key}":`, error);
      return key;
    }
  }
  return translatedText;
};
